import { useQuery } from "urql"

import "../graphql/vendorApLedger.query"

import { GetVendorApLedgerBalanceDocument } from "@/graphql/codegen/graphql"

interface UseGetVendorApLedgerBalanceParams {
  companyId: string
  pause?: boolean
}

interface UseGetVendorApLedgerBalanceReturn {
  balance: number | undefined
  isFetching: boolean
  error: string | undefined
}

export const useGetVendorApLedgerBalance = ({
  companyId,
  pause = false,
}: UseGetVendorApLedgerBalanceParams): UseGetVendorApLedgerBalanceReturn => {
  const [{ data, fetching, error }] = useQuery({
    query: GetVendorApLedgerBalanceDocument,
    variables: { input: { vendorCompanyId: companyId } },
    pause,
  })

  const output = data?.vendorApLedger.get
  const failureMessage = output?.__typename === "VendorApLedgerGetFailure" ? output.error.message : undefined

  return {
    balance: output?.__typename === "VendorApLedgerGetSuccess" ? output.vendorApLedger.balance : undefined,
    isFetching: fetching,
    error: error?.message ?? failureMessage,
  }
}
